import React from 'react'
import styled from 'styled-components'
import { Borders, Colors, Fonts, FontWeights, INTEGRAL_LP_SYMBOL } from '../constants'
import { Pair } from '../model'
import { CurrencySymbolImage, UseWethButton } from './input'
import { usePairSelectModal } from '../providers'

interface Props {
  pair?: Pair
  symbol: string
  value: string
  balance: string
  rate?: string
  className?: string
}

export function Receive({ pair, symbol, value, balance, rate, className }: Props) {
  const displayedSymbol = getDisplayedSymbol(symbol, pair)
  const { togglePairSelectModal } = usePairSelectModal()

  return (
    <Container className={className}>
      <InputItemTopRow>
        <InputItemLabel>You Receive (Estimated)</InputItemLabel>
        {rate && <Rate>{rate ?? '-'}</Rate>}
      </InputItemTopRow>
      <Amount>
        <span>{value}</span>
        <ImageContainer onClick={togglePairSelectModal}>
          <CurrencySymbolImageStyled symbol={symbol} />
          {displayedSymbol}
        </ImageContainer>
      </Amount>
      <InputItemBottomRow>
        <Balance>Wallet: {balance}</Balance>
        <UseWethButton symbol={symbol} />
      </InputItemBottomRow>
    </Container>
  )
}

function getDisplayedSymbol(symbol: string, pair?: Pair) {
  if (symbol === INTEGRAL_LP_SYMBOL) {
    return pair ? `${pair.getToken0Symbol()}-${pair.getToken1Symbol()}` : ''
  }
  return symbol
}

const Container = styled.div`
  margin-bottom: 10px;
  padding: 0 20px;
  text-transform: uppercase;
`

const InputItemTopRow = styled.div`
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
`

const InputItemLabel = styled.strong`
  margin: 0;
  display: block;
  font-size: 11px;
`

const Rate = styled.p`
  margin: 0;
  display: block;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  text-transform: uppercase;
`

const Amount = styled.div`
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
  background: rgb(239, 239, 239);
  background: linear-gradient(0deg, rgba(241, 246, 255, 1) 0%, rgba(234, 241, 253, 1) 100%);

  span {
    margin-right: 5px;
    font-size: 18px;
    font-family: ${Fonts.Monospace};
    font-weight: ${FontWeights.Bold};
  }
`

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
  cursor: pointer;
`
const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`

const InputItemBottomRow = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Balance = styled.p`
  margin: 0;
  display: block;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  text-transform: uppercase;
`
